package org.maplibre.compose.demoapp

import androidx.compose.runtime.Composable

/** Only Android offers a choice of presentation. */
@Composable actual fun RenderModeRow(settings: DemoSettings) {}
